import { Routes } from '@angular/router';


export  const botUIRoutes: Routes = [{path: '', loadComponent:()=> import('./chatbot-home/chatbot-home.component').then(m => m.ChatbotHomeComponent),
children: [
  {
    path: 'landing', // Child route (parent/a)
    loadComponent: () => import('./ab-chatbot-landing-page/ab-chatbot-landing-page.component').then(m => m.AbChatbotLandingPageComponent)
  },
  {
    path:"landing/:src/:lang",
    loadComponent: () => import('./ab-chatbot-landing-page/ab-chatbot-landing-page.component').then(m => m.AbChatbotLandingPageComponent)
  },
  {
    path: 'mainChat', 
    loadComponent: () => import('./main-chat-area/main-chat-area.component').then(m => m.MainChatAreaComponent)
  },
  {
    path:'profile',
    loadComponent: () => import('./profile-attribute/profile-attribute.component').then(m => m.ProfileAttributeComponent)
  },
  {
    path:'noAgent', 
    loadComponent:() => import('./no-agent-screen/no-agent-screen.component').then(m => m.NoAgentScreenComponent)
  }
]

},];

